var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldRupeLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_145_632)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 32.0001,
    r: 20.6054,
    fill: "url(#paint0_linear_145_632)",
    stroke: "url(#paint1_linear_145_632)",
    strokeWidth: 2.78923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8937,
    cy: 31.8927,
    r: 19.5101,
    fill: "url(#paint2_linear_145_632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7894 42.0001L29 33.6443V31.6751H30.5965C31.235 31.6751 31.7938 31.5864 32.2727 31.409C32.7694 31.2139 33.1774 30.9389 33.4967 30.5841C33.8337 30.2293 34.0643 29.8035 34.1885 29.3068H29V27.3376H34.1619C34.0554 26.8763 33.8692 26.4683 33.6031 26.1135C33.3548 25.7587 33.0177 25.4837 32.592 25.2886C32.184 25.0757 31.6874 24.9692 31.102 24.9692H29V23.0001H41V24.9692H36.8226C37.1242 25.3063 37.3725 25.67 37.5676 26.0603C37.7805 26.4506 37.9224 26.8763 37.9933 27.3376H41V29.3068H38.0466C37.8692 30.6196 37.3636 31.6485 36.5299 32.3936C35.6962 33.121 34.6231 33.6177 33.3104 33.8838L38.5255 42.0001H33.7894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_145_632",
    x: 0.085887,
    y: 0.0276594,
    width: 69.8282,
    height: 69.8282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.94171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.45706
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_632",
    x1: 56.12,
    y1: 53.1201,
    x2: 16.52,
    y2: 11.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_632",
    x1: 18.5,
    y1: 19.1667,
    x2: 44.1667,
    y2: 45.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_632",
    x1: 24.9119,
    y1: 23.7478,
    x2: 51.4952,
    y2: 53.9978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRupeLg);
export default __webpack_public_path__ + "static/media/gold_rupe_lg.500a69b4918c0ad0c50290b0c319a4c5.svg";
export { ForwardRef as ReactComponent };